import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VideoStreamingMode } from 'features/live/liveVideoStreaming';
import { navigate } from 'features/location/types';
import { HYDRATE, initialBoundingRect, initialState, WindowResizePayloadType, WindowScrollPayloadType } from 'features/settings/type';

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setIsVisualizzazioneEstesa: (state, { payload }: PayloadAction<boolean>) => {
      state.isVisualizzazioneEstesa = payload;
    },
    setStreamingMode: (state, { payload }: PayloadAction<VideoStreamingMode>) => {
      state.streamingMode = payload;
    },
    updatePosition: (state, { payload }: PayloadAction<WindowScrollPayloadType>) => {
      state.boundingRect = state.boundingRect ?? { ...initialBoundingRect };
      if (state.boundingRect.top !== payload.top) {
        state.boundingRect.top = payload.top;
      }
      if (state.boundingRect.left !== payload.left) {
        state.boundingRect.left = payload.left;
      }
    },
    updateSize: (state, { payload }: PayloadAction<WindowResizePayloadType>) => {
      state.boundingRect = state.boundingRect ?? { ...initialBoundingRect };
      if (state.boundingRect.width !== payload.width) {
        state.boundingRect.width = payload.width;
      }
      if (state.boundingRect.height !== payload.height) {
        state.boundingRect.height = payload.height;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => [HYDRATE, navigate.pending.type].includes(action.type),
      (state) => {
        state.streamingMode = VideoStreamingMode.off;
      }
    );
  },
});

export const { updatePosition, updateSize, setStreamingMode, setIsVisualizzazioneEstesa } = settingsSlice.actions;

export default settingsSlice.reducer;